import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

class AuthService {
  login(email, password) {
    return axios
      .post(`${API_URL}/admin/login`, { email, password })
      .then((response) => {
        if (response.data.access_token) {
          localStorage.setItem('admin', JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('admin');
  }

  getCurrentAdmin() {
    const admin = localStorage.getItem('admin');
    return admin ? JSON.parse(admin) : null;
  }

  getToken() {
    const admin = this.getCurrentAdmin();
    return admin?.access_token;
  }

  getAuthHeader() {
    const token = this.getToken();
    if (token) {
      return { Authorization: `Bearer ${token}` };
    }
    return {};
  }
}

export default new AuthService();
